/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Trips_Delete_DescInputs */

const en_ui_trips_delete_desc = /** @type {(inputs: Ui_Trips_Delete_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"? Your sessions stay — only the trip is removed.`)
};

const de_ui_trips_delete_desc = /** @type {(inputs: Ui_Trips_Delete_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.name}“ löschen? Deine Einheiten bleiben – nur die Tour wird entfernt.`)
};

/**
* | output |
* | --- |
* | "Delete \"{name}\"? Your sessions stay — only the trip is removed." |
*
* @param {Ui_Trips_Delete_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_delete_desc = /** @type {((inputs: Ui_Trips_Delete_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Delete_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_delete_desc(inputs)
	return de_ui_trips_delete_desc(inputs)
});